module.exports = __webpack_public_path__ + "static/media/011.d799c2a3.jpg";